// @flow
import React from 'react'
import {FormattedNumber} from 'react-intl'
import {Arrow, toDirection} from '../../shared/Arrow'
import {endring as cnEndring} from './index.css'

type EndringProps = {
  endring: number,
  digits?: ?number
}

export function Endring(props: EndringProps) {
  const {endring, digits = 1} = props
  if (Number.isNaN(endring)) {
    return <span>&mdash;</span>
  }

  return (
    <span className={cnEndring}>
      <span>
        {endring > 0 ? '+' : ''}
        <FormattedNumber value={endring} minimumFractionDigits={digits} />
      </span>
      <Arrow direction={toDirection(endring)} />
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/shared/Endring/index.js